import { isVNode as _isVNode, createVNode as _createVNode } from "vue";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
/* eslint-disable complexity */
import { defineComponent, resolveComponent } from 'vue';
import { useStyleConfig } from '../abstract';
import StepinLink from '../stepin-link';
import { MenuItem, SubMenu, Badge } from 'ant-design-vue';
/**
 * 获取菜单徽标
 * @param config
 */
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
function getBadge(config) {
  var _config$meta, _config$meta2, _config$children;
  if (((_config$meta = config.meta) === null || _config$meta === void 0 ? void 0 : _config$meta.badge) !== undefined && ((_config$meta2 = config.meta) === null || _config$meta2 === void 0 ? void 0 : _config$meta2.badge) !== '') {
    var _config$meta3;
    return (_config$meta3 = config.meta) === null || _config$meta3 === void 0 ? void 0 : _config$meta3.badge;
  }
  if (((_config$children = config.children) === null || _config$children === void 0 ? void 0 : _config$children.length) > 0) {
    var _iterator = _createForOfIteratorHelper(config.children),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        var badge = getBadge(child);
        if (badge !== undefined && badge !== '') {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return undefined;
}
/**
 * 获取 Badge 组件属性
 * @param badge
 */
function getBadgeProps(badge) {
  return badge === true ? {
    dot: true,
    showZero: true
  } : badge === false ? {} : {
    count: badge,
    showZero: true
  };
}
/**
 * 解析菜单图标
 * @param icon
 */
function resolveMenuIcon(icon) {
  return typeof icon === 'string' ? resolveComponent(icon) : icon;
}
/**
 * 渲染含有子菜单的菜单
 * @param config
 * @param clsPrefix 类名前缀
 */
function renderSubMenu(config, clsPrefix, popupClassName) {
  var _config$meta4, _config$key;
  var badge = getBadge(config);
  var badgeProps = getBadgeProps(badge);
  var children = config.children.map(function (item) {
    return renderMenuItem(item, clsPrefix, popupClassName);
  });
  var title = _createVNode("span", {
    "class": "".concat(clsPrefix, "-submenu-title")
  }, [badge !== undefined ? _createVNode(Badge, badgeProps, {
    default: function _default() {
      return [config.title];
    }
  }) : config.title]);
  var MenuIcon = resolveMenuIcon((_config$meta4 = config.meta) === null || _config$meta4 === void 0 ? void 0 : _config$meta4.icon);
  return _createVNode(SubMenu, {
    "class": MenuIcon ? '' : 'virtual-icon',
    "popupClassName": "".concat(clsPrefix, "-submenu-popup ").concat(popupClassName !== null && popupClassName !== void 0 ? popupClassName : '', " ").concat(MenuIcon ? '' : 'virtual-icon'),
    "title": title,
    "key": (_config$key = config.key) !== null && _config$key !== void 0 ? _config$key : config.path
  }, {
    default: function _default() {
      return [children];
    },
    icon: renderIcon(MenuIcon, config.title, badgeProps)
  });
}
/**
 * 渲染图标
 * @param MenuIcon
 * @param title
 * @param badgeProps
 */
function renderIcon(MenuIcon, title, badgeProps) {
  return function () {
    var _slot;
    return MenuIcon ? _createVNode(Badge, badgeProps, {
      default: function _default() {
        return [_createVNode(MenuIcon, null, null)];
      }
    }) : _createVNode(Badge, badgeProps, _isSlot(_slot = title.substring(0, 1)) ? _slot : {
      default: function _default() {
        return [_slot];
      }
    });
  };
}
/**
 * 渲染菜单
 * @param config
 * @param clsPrefix 类名前缀
 */
function renderMenuItem(config, clsPrefix, popupClassName) {
  var _config$meta5, _config$children2, _config$key2, _config$meta$redirect, _config$meta6;
  var badge = getBadge(config);
  var badgeProps = getBadgeProps(badge);
  var _ref = (_config$meta5 = config.meta) !== null && _config$meta5 !== void 0 ? _config$meta5 : {},
    href = _ref.href,
    target = _ref.target,
    view = _ref.view,
    icon = _ref.icon;
  var _target = target !== null && target !== void 0 ? target : href ? '_blank' : '_self';
  var MenuIcon = resolveMenuIcon(icon);
  return ((_config$children2 = config.children) === null || _config$children2 === void 0 ? void 0 : _config$children2.length) > 0 ? renderSubMenu(config, clsPrefix, popupClassName) : _createVNode(MenuItem, {
    "key": (_config$key2 = config.key) !== null && _config$key2 !== void 0 ? _config$key2 : config.path,
    "class": MenuIcon ? '' : 'virtual-icon'
  }, {
    default: function _default() {
      return [_createVNode(StepinLink, {
        "target": _target,
        "href": href,
        "to": {
          path: (_config$meta$redirect = (_config$meta6 = config.meta) === null || _config$meta6 === void 0 ? void 0 : _config$meta6.redirect) !== null && _config$meta$redirect !== void 0 ? _config$meta$redirect : config.path,
          query: {
            _to_view: view
          }
        }
      }, {
        default: function _default() {
          return [badge !== undefined ? _createVNode(Badge, badgeProps, {
            default: function _default() {
              return [config.title];
            }
          }) : config.title];
        }
      })];
    },
    icon: renderIcon(MenuIcon, config.title, badgeProps)
  });
}
export default defineComponent({
  name: 'RouterMenuItem',
  props: {
    config: Object,
    popupClassName: String
  },
  render: function render() {
    var _useStyleConfig = useStyleConfig('router-menu-item'),
      rootPrefix = _useStyleConfig.rootPrefix;
    var config = this.config,
      popupClassName = this.popupClassName;
    return renderMenuItem(config, rootPrefix.value, popupClassName);
  }
});